import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudUpload } from '@fortawesome/pro-light-svg-icons'

import GlobalContext from 'agency/digital_renderer/utils/context'
import replaceTextShortCodes from 'functions/replaceTextShortCodes'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'
import { digObject, sortArrayBy } from 'functions/utilities'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'

import styles from './styles.scss'

const permittedTypes = ['proposal_image', 'custom_image']

const getImageUrlFromAttachment = (props, context) => {
  const { id } = props
  const { attachments } = context
  const sortedAttachments = Array.isArray(attachments) ? sortArrayBy(attachments, 'desc', 'id') : []

  const attachment = sortedAttachments.find((item) => {
    const { attachment_type, data } = item
    const { digital_template_item_id } = data || {}

    return permittedTypes.includes(attachment_type) && digital_template_item_id === id
  }) || {}

  return digObject(attachment, 'links.preserved_1120x1120')
}

const imageStyle = (defaultStyle, imageUrl) => {
  let backgroundImage = imageUrl ? `url(${imageUrl})` : null
  if (!backgroundImage) backgroundImage = defaultStyle.backgroundImage || null

  return {
    ...defaultStyle,
    backgroundImage,
  }
}

const Image = (props) => {
  const {
    children,
    context: componentContext,
    data: { value },
    options,
    id,
  } = props
  const { editable } = options || {}

  const style = deviceStyle(props)

  const defaultContext = useContext(GlobalContext)
  const {
    editing,
    callbacks: { setGlobalState },
  } = defaultContext

  const context = { ...defaultContext, ...componentContext }
  const imageUrl = editable ? getImageUrlFromAttachment(props, context) : replaceTextShortCodes(value, context)
  const isEditable = editing && editable

  const ComponentTag = isEditable ? 'a' : 'span'

  return (
    <AnimationWrapper options={options}>
      <ComponentTag
        className={isEditable ? classnames(styles.root, styles.editable) : styles.root}
        style={imageStyle(style, imageUrl)}
        onClick={isEditable ? () => setGlobalState({ showImageSelectModal: true, selectedItemId: id }) : null}
      >
        {children}

        {isEditable && (
          <>
            <span className={styles.changeText}>
              <FontAwesomeIcon icon={faCloudUpload} style={{ marginRight: 5 }} />
              Change or Upload
            </span>
          </>
        )}
      </ComponentTag>
    </AnimationWrapper>
  )
}

Image.propTypes = {
  children: PropTypes.node,
  context: PropTypes.object,
  data: PropTypes.object,
  id: PropTypes.string,
  options: PropTypes.object,
}

export default Image
